import React, { useEffect, useState, useMemo } from 'react';
import { Modal, Button, Row, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { alertActions, adminActions } from '../../redux/_actions';
import LeagueForm from './leagueform';
import LeagueDetail from './leaguedetail';
import TableComponent from '../helpers/tablecomponent';
import { modeType } from '../../utilities/constants';
import { Loading, ScrollLoading } from '../helpers/loading';
import { SearchInput, addBold, noResults } from '../helpers/search';

function LeagueAdmin(props) {
  const { setIsForm } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [isScrollLoading, setIsScrollLoading] = useState(false);
  const { LIST, DETAIL, EDIT, DELETE, ADD } = modeType;
  const [mode, setMode] = useState(LIST);
  const [leagueId, setLeagueId] = useState(null);
  const alert = useSelector((state) => state.alert);
  const leagues = useSelector((state) => state.admin.leagues);
  const nextToken = useSelector(
    (state) => state.admin.leagues.tokens.nextToken
  );
  const searchQuery = useSelector(
    (state) => state.admin.leagues.tokens.searchQuery
  );
  const searchToken = useSelector(
    (state) => state.admin.leagues.tokens.searchToken
  );

  const [searchTerm, setSearchTerm] = useState(searchQuery || '');
  const [tempSearchTerm, setTempSearchTerm] = useState(searchQuery || ''); // used for async holding of query
  const dispatch = useDispatch();
  const numLeagues = leagues?.allIds?.length || 0;
  const isSearch = searchTerm !== '';
  let lastScrollTop = 0;

  useEffect(() => {
    dispatch(alertActions.clear());
    setIsLoading(true);
    dispatch(adminActions.getLeagues());
  }, [dispatch]);

  useEffect(() => {
    if (leagues.allIds) {
      setIsLoading(false);
    }
  }, [leagues.allIds]);

  useEffect(() => {
    setIsScrollLoading(false);
    setSearchTerm(tempSearchTerm);
  }, [leagues, tempSearchTerm]);

  const leagueDetail = (e, row) => {
    if (!alert.clear) {
      dispatch(alertActions.clear());
    }
    setLeagueId(row.id);
    setMode(DETAIL);
    setIsForm(true);
  };

  const back = () => {
    setMode(LIST);
    setIsForm(false);
  };

  const add = () => {
    setMode(ADD);
    setIsForm(true);
  };

  const headers = useMemo(
    () => [
      { Header: '#', accessor: 'order' },
      {
        Header: 'Name',
        accessor: 'name',
        Cell: (r) => addBold(r.cell.value, searchTerm),
      },
      { Header: 'Type', accessor: 'type' },
      { Header: 'Gender', accessor: 'gender' },
      { Header: 'Teams', accessor: 'teams' },
    ],
    [searchTerm]
  );

  const data = useMemo(() => {
    return leagues.allIds.map((id, i) => {
      const { name, type, gender /*teams*/ } = leagues.byId[id];

      return {
        order: i + 1,
        name: name,
        type: type,
        gender: gender,
        teams: 'TBD', //teams.items.length,
        id: id,
      };
    });
  }, [leagues]);

  const table = () => {
    const initialState = {
      sortBy: [{ id: 'name', desc: false }],
    };

    const empty = numLeagues === 0 || data.length === 0;
    const searchEmpty = isSearch && data.length === 0;

    return empty ? (
      noResults(searchEmpty ? 'search results' : 'leagues')
    ) : (
      <TableComponent
        columns={headers}
        data={data}
        onClick={leagueDetail}
        initialState={initialState}
        textSort={true}
        searchTerm={searchTerm}
        showFooter={true}
        filterColumns={['name']}
      />
    );
  };

  const handleScroll = (e) => {
    const { scrollHeight, scrollTop, scrollLeft, clientHeight } = e.target;
    const bottom = scrollHeight - scrollTop === clientHeight;
    const nextPage =
      (isSearch && searchToken !== null) ||
      (!isSearch && nextToken !== null && numLeagues !== 0);
    const vertScroll =
      scrollLeft === 0 && scrollTop !== lastScrollTop && lastScrollTop !== 0;

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

    if (bottom && nextPage && vertScroll && !isScrollLoading) {
      setIsScrollLoading(true);
      dispatch(
        adminActions.getLeagues({
          searchQuery: searchTerm,
          nextToken: isSearch ? searchToken : nextToken,
        })
      );
    }
  };

  const handleSearch = (query) => {
    setTempSearchTerm(query);

    if (query && query !== '') {
      dispatch(
        adminActions.getLeagues({ searchQuery: query, nextToken: null })
      );
    } else {
      // clear search
      setSearchTerm(query);
    }
  };

  const adminBody = () => {
    return (
      <>
        {!alert.clear ? (
          <Row style={{ padding: '0 15px', margin: '1rem -15px' }}>
            <Alert
              dismissible
              onClose={() => dispatch(alertActions.clear())}
              variant={alert.type === 'alert-danger' ? 'danger' : 'success'}
              style={{ textAlign: 'center', width: '100%' }}
            >
              {alert.message}
            </Alert>
          </Row>
        ) : null}
        {isLoading ? <Loading /> : table()}
      </>
    );
  };

  const footer = () => {
    return (
      <>
        <Row className="vCenter" style={{ margin: '0 auto' }}>
          <Button
            variant="outline-primary"
            className="formButton"
            onClick={add}
            disabled={isLoading}
          >
            Add league
          </Button>
        </Row>
        <Row />
      </>
    );
  };

  const headerMsg = () => {
    return <span>League Admin</span>;
  };

  const listModal = () => {
    return (
      <>
        <Modal.Header className="searchHeader">
          {headerMsg()}
          {numLeagues !== 0 && data?.length !== 0 ? (
            <SearchInput searchTerm={searchTerm} search={handleSearch} />
          ) : null}
        </Modal.Header>
        <Modal.Body className="setupForm" onScroll={handleScroll}>
          {adminBody()}
          {isScrollLoading ? <ScrollLoading /> : null}
        </Modal.Body>
        <Modal.Footer className="setupFooter">{footer()}</Modal.Footer>
      </>
    );
  };

  const modal = () => {
    switch (mode) {
      case ADD:
        return <LeagueForm back={back} />;
      case EDIT:
        break;
      case DELETE:
        break;
      case LIST:
        return listModal();
      case DETAIL:
        return <LeagueDetail back={back} leagueId={leagueId} />;
      default:
        return null;
    }
  };

  return modal();
}

export default LeagueAdmin;
